import api from "./config/axiosConfig";

const SITE_IMAGES_URL = "/site-images";

// { slot: image } and { gallerySlot: [images] }, for the places the admin
// has filled; image = { url, width, height, alt, sizes: [{ url, width, height }] }
export const getSiteImages = async () => {
  const response = await api.get(`${SITE_IMAGES_URL}/`, {
    shouldIncludeToke: false,
  });
  return response.data;
};
